import React, { useMemo } from "react";
import MetaTags from "react-meta-tags";
import jwt_decode from "jwt-decode";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

import AutomatedEmailsSettings from "./AutomatedEmailsSettings";
import "./automated-emails.scss";

const getRoleFromToken = () => {
  try {
    const token = localStorage.getItem("accessToken");
    return token ? jwt_decode(token)?.role : null;
  } catch {
    return null;
  }
};

const AutomatedEmailsPage = () => {
  const role = useMemo(getRoleFromToken, []);
  const readOnly = role !== "company";

  return (
    <div className="page-content">
      <MetaTags>
        <title>Rentdigicare | Automated Emails</title>
      </MetaTags>
      <div className="container-fluid">
        <Breadcrumbs title="Company" breadcrumbItem="Automated Emails" />

        <p className="ae-intro">
          These emails go out on their own. Switch any of them off, add extra
          addresses, or send yourself a sample to see what people receive.
        </p>

        <AutomatedEmailsSettings readOnly={readOnly} />
      </div>
    </div>
  );
};

export { AutomatedEmailsPage };
export default AutomatedEmailsPage;
